import { Box, LinearProgress } from '@mui/material';

interface LinearBarProps {
    loading: boolean;
}
export function LinearBar({ loading }: LinearBarProps) {
    return <Box height={4}>{loading && <LinearProgress />}</Box>;
}
